import { getEventBusIfDefined } from '@cian/event-bus';

import get from 'lodash/get';
import * as React from 'react';

import { ISpecialPromoLinkData } from '../../../app/models/promo';

import { ITopMenuLinks, TopMenu } from '../../components/TopMenu';
import { IMenuLink, MENU_LINKS } from '../../constants/menuLinks';
import { IHeaderV1Schema } from '../../repositories/header/entities/response/HeaderV1Schema';
import { IDropdownMenuContainerProps } from '../DropdownMenuContainer';
import { IExperiment } from '../../types/experiments';
import { getExperiment } from '../../utils/experiments/getExperiment';
import { DEAL_RENT_MENU_ITEM_TITLE_EXPERIMENT_NAME } from '../../constants/config/experiments';

export interface ITopMenuContainerProps {
  dropdownMenusData: { [key: string]: IDropdownMenuContainerProps };
  specialPromoLinkData: ISpecialPromoLinkData;
  headerData: IHeaderV1Schema;
  menuLinks: IMenuLink[];
  activeKey?: string;
  regionId: number;
  experiments: IExperiment[];
}

export interface ITopMenuContainerState {
  activeKey?: string;
}

export class TopMenuContainer extends React.Component<ITopMenuContainerProps, ITopMenuContainerState> {
  public constructor(props: ITopMenuContainerProps) {
    super(props);

    this.state = {
      activeKey: props.activeKey,
    };
  }

  public static defaultProps = {
    menuLinks: MENU_LINKS,
  };

  public componentDidMount() {
    const eventBus = getEventBusIfDefined();

    if (eventBus) {
      eventBus.subscribe('header:category_changed', this.categoryChangedHandler);
    }
  }

  public render() {
    const { dropdownMenusData, specialPromoLinkData, regionId } = this.props;
    const { activeKey } = this.state;

    return (
      <TopMenu
        dropdownMenusData={dropdownMenusData}
        specialPromoLinkData={specialPromoLinkData}
        menuLinks={this.makeMenuLinks()}
        catalogDevelopersUrl={this.getCatalogDevelopersUrl()}
        catalogRealtorsUrl={this.getCatalogRealtorsUrl()}
        otherLinks={this.getOtherLinks()}
        activeKey={activeKey}
        regionId={regionId}
      />
    );
  }

  private categoryChangedHandler = (event: CianEventBus.IEvent) => {
    const { type } = event;

    this.setState({ activeKey: type });
  };

  private makeMenuLinks = (): ITopMenuLinks[] => {
    const { menuLinks, headerData, regionId } = this.props;
    const dealRentMenuItemTitleExperimentGroup = this.getDealRentMenuItemTitleExperimentGroup();

    const mappedMenuLinks = menuLinks.map(menuLink => {
      const { name, title, trackingLabel, path, section, regionIds } = menuLink;
      const link = path && get(headerData, path);
      const newTitle = this.getTitle(section, title);

      return {
        name,
        title: newTitle,
        trackingLabel,
        link,
        section,
        regionIds,
      };
    });

    const filteredMenuLinks = mappedMenuLinks.filter(l => {
      const skip = !Boolean(dealRentMenuItemTitleExperimentGroup) && l.section === 'dealRent';
      const regionFilterExists = Array.isArray(l.regionIds) && l.regionIds.length > 0;

      return !skip && (!regionFilterExists || (regionFilterExists && l.regionIds?.includes(regionId)));
    });

    return filteredMenuLinks;
  };

  private getTitle = (section: string | undefined, title: string): string => {
    if (section !== 'dealRent') {
      return title;
    }
    const dealRentMenuItemTitleExperimentGroup = this.getDealRentMenuItemTitleExperimentGroup();

    switch (dealRentMenuItemTitleExperimentGroup) {
      case 'A':
        return 'Сдай/Сними';
      case 'B':
        return 'Аренда от Циан';
      default:
        return 'Сдай/Сними';
    }
  };

  private getDealRentMenuItemTitleExperimentGroup = (): string | null | undefined => {
    const { experiments } = this.props;
    const experiment = getExperiment(experiments, DEAL_RENT_MENU_ITEM_TITLE_EXPERIMENT_NAME);

    return experiment?.groupName;
  };

  private getCatalogDevelopersUrl = () => {
    const { headerData } = this.props;

    if (headerData && headerData.catalogDevelopers) {
      return headerData.catalogDevelopers;
    }

    return '';
  };

  private getCatalogRealtorsUrl = () => {
    const { headerData } = this.props;

    if (headerData?.catalogRealtors) {
      return headerData.catalogRealtors;
    }

    return '';
  };

  private getOtherLinks = () => {
    const { headerData } = this.props;

    if (headerData && headerData.otherLinks) {
      return headerData.otherLinks;
    }

    return undefined;
  };
}
